import { render, staticRenderFns } from "./TheConfirm.vue?vue&type=template&id=2b75d59c"
import script from "./TheConfirm.vue?vue&type=script&lang=js"
export * from "./TheConfirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports